import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ_IDS = ['1', '2', '3', '4', '5'];

export const FAQ = () => {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-testid="faq-title">
            {t('faq.title')}
          </h2>
          <p className="text-xl text-gray-600">
            {t('faq.subtitle')}
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {FAQ_IDS.map((id) => (
              <AccordionItem 
                key={id} 
                value={`item-${id}`}
                className="border border-gray-200 rounded-lg px-6 hover:border-amber-300 transition-colors"
                data-testid={`faq-item-${id}`}
              >
                <AccordionTrigger className="text-left hover:no-underline py-6">
                  <span className="font-semibold text-gray-900 pr-4">
                    {t(`faq.items.${id}.q`)}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pb-6">
                  {t(`faq.items.${id}.a`)}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Additional Help */}
          <div className="mt-12 text-center p-8 bg-gradient-to-r from-amber-50 to-amber-100 rounded-xl">
            <p className="text-gray-700 mb-4">
              {t('faq.no_answer')}
            </p>
            <a href="https://wa.me/351932651940" target="_blank" rel="noopener noreferrer">
              <span className="text-amber-700 font-semibold hover:text-amber-800 cursor-pointer" data-testid="faq-contact-link">
                {t('faq.contact_us')}
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
